/**
 * Copyright (C) 2021 盈宝信息科技（广州）有限公司 All Rights Reserved.
 */

import { Toast, Dialog } from 'vant'
import i18n from '@/language'
import AppTheme from '@/theme/themes'

/**
 * 盈宝Toast
 * @param {String} msg 弹出信息
 */
function wbToast(msg) {
  Toast({
    type: 'html',
    message: `<div class="wb-toast"><div class="wb-toast-text">${msg}</div></div>`
  })
}

/**
 * 盈宝alert
 * @param {Function} callback 回调
 * @param {String} msg 弹出信息
 * @param {Object} option 配置
 */
function wbAlert(msg, callback, option = { btnText: i18n.t('common.confirm') }) {
  Dialog.alert({
    message: msg,
    confirmButtonText: option.btnText,
    theme: 'round-button',
    className: 'wb-alert',
    overlayClass: 'wb-alert-overlay'
  }).then(() => {
    const dCb = Dialog.close
    callback(dCb)
  })
}

/**
 * 盈宝loading
 */
function wbLoading() {
  const loadingGif = AppTheme.getThemeAsset('loadingAnima')
  Toast.loading({
    duration: 0,
    forbidClick: true,
    className: 'wb-loading',
    overlay: true,
    icon: loadingGif
  })
  return () => Toast.clear(false)
}

export { wbToast, wbLoading, wbAlert }
